import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const [height, setHeight] = React.useState(window.innerHeight);

  React.useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <footer style={{
      width: '100%',
      backgroundColor: 'white',
      padding: height < 1000 ? '0px' : '0px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      justifyContent: 'center',
    }}>
      <img 
        src={`${process.env.PUBLIC_URL}/Dicapta.png`}
        alt="Dicapta Logo"
        style={{ height: height < 1200 ? '75px' : '100px' }}
      />
      <p style={{ 
        color: 'black',
        fontSize: height < 1000 ? '0.9rem' : '1.25rem',
        margin: 0,
      }}>
        INTEGRA: Generative Intelligent Video Modeling to support the participation of Latino English Learners (LELs) with disabilities
      </p>
    </footer>
  );
};

export default Footer; 